import { BodyText, Button } from '@paypalcorp/pp-react';
import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import Slider from 'react-slick';
import { SampleNextArrow, SamplePrevArrow } from './arrows';

import {
  Container,
  Block,
  Title,
  Images,
  Image,
  Circle,
  Slide,
} from './redux/components/styles/donation-steps';

export default class DonationSteps extends Component {
  renderBig(steps) {
    const [step1, step2, step3] = steps.steps;

    return (
      <Container>
        <Title as='h2' size='sm'>
          {steps.title}
        </Title>
        <Images>
          <Image src={step1.image} alt='' />
          <Image
            src={`https://${this.props.cdnHost}/webstatic/ppgf/donationtracker/arrow1.svg`}
            alt=''
          />
          <Image src={step2.image} alt='' />
          <Image
            src={`https://${this.props.cdnHost}/webstatic/ppgf/donationtracker/arrow2.svg`}
            alt=''
          />
          <Image src={step3.image} alt='' />
        </Images>
        <div className='row steps-section'>
          <div className='col-sm-4' style={{ display: 'flex' }}>
            <p className='circle'>
              <Circle>{step1.step}</Circle>
            </p>
            <BodyText as='p' size='md' className='step-text'>
              {step1.text}
            </BodyText>
          </div>
          <div className='col-sm-4' style={{ display: 'flex' }}>
            <p className='circle'>
              <Circle>{step2.step}</Circle>
            </p>
            <BodyText
              as='p'
              size='md'
              className='step-text'
              dangerouslySetInnerHTML={{ __html: step2.text }}
            />
          </div>
          <div className='col-sm-4' style={{ display: 'flex' }}>
            <p className='circle'>
              <Circle>{step3.step}</Circle>
            </p>
            <BodyText
              as='p'
              size='md'
              className='step-text'
              dangerouslySetInnerHTML={{ __html: step3.text }}
            />
          </div>
        </div>
      </Container>
    );
  }

  renderSmall(steps) {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow cdnHost={this.props.cdnHost} />,
      prevArrow: <SamplePrevArrow cdnHost={this.props.cdnHost} />,
    };

    const slides = steps.steps.map((step, index) => {
      return (
        <div key={`donation-step-${index}`}>
          <Image src={step.image} alt='' />
          <Slide>
            <Circle>{step.step}</Circle>
            <BodyText
              as='p'
              size='md'
              className='step-text'
              dangerouslySetInnerHTML={{ __html: step.text }}
            />
          </Slide>
        </div>
      );
    });

    return (
      <Container>
        <Title as='h2' size='md'>
          {steps.title}
        </Title>
        <Slider {...settings}>{slides}</Slider>
      </Container>
    );
  }

  renderButton() {
    return (
      <Button
        as='a'
        target='_blank'
        size='lg'
        secondary
        href={this.props.i18n('label.donation-href')}
      >
        {this.props.i18n('label.donationStep-button')}
      </Button>
    );
  }

  render() {
    const steps = {
      title: this.props.i18n('label.donationStep-title'),
      steps: [
        {
          step: this.props.i18n('label.donationStep-step1'),
          text: this.props.i18n('label.donation-step1-text'),
          image: `https://${this.props.cdnHost}/webstatic/ppgf/donationtracker/step1.svg`,
        },
        {
          step: this.props.i18n('label.donationStep-step2'),
          text: this.props.i18n('label.donation-step2-text'),
          image: `https://${this.props.cdnHost}/webstatic/ppgf/donationtracker/step2.svg`,
        },
        {
          step: this.props.i18n('label.donationStep-step3'),
          text: this.props.i18n('label.donation-step3-text'),
          image: `https://${this.props.cdnHost}/webstatic/ppgf/donationtracker/step3.svg`,
        },
      ],
    };

    return (
      <Block className='panel'>
        <MediaQuery minWidth={1200}>{this.renderBig(steps)}</MediaQuery>
        <MediaQuery maxWidth={1199}>{this.renderSmall(steps)}</MediaQuery>
        <MediaQuery minWidth={1200}>
          <Container>{this.renderButton()}</Container>
        </MediaQuery>
      </Block>
    );
  }
}
